export enum StickyButtonsEvents {
	GO_TO_PLAYER = 'gotoplayer',
	CLOSE = 'close'
}
